import useDocumentTitle from '../hooks/useDocumentTitle';

const processHeroImg = require('../Assert/17.jpg');

const phases = [
  {
    number: '01',
    label: 'PHASE ONE',
    title: 'Discovery',
    description: (
      <>
        We ask the questions most agencies skip.
        <br />
        What do you actually need.
        <br />
        What does success look like.
        <br />
        What already has been tried.
      </>
    ),
  },
  {
    number: '02',
    label: 'PHASE TWO',
    title: 'Strategy and Architecture',
    description:
      'Before a single line of code, we map the full system. Tech stack, data flow, agent logic, integration points.',
  },
  {
    number: '03',
    label: 'PHASE THREE',
    title: 'Design',
    description:
      'Interfaces built for people who will actually use them. Functional, fast, and human.',
  },
  {
    number: '04',
    label: 'PHASE FOUR',
    title: 'Build',
    description:
      'Iterative development, real checkpoints, no black-box surprises.',
  },
  {
    number: '05',
    label: 'PHASE FIVE',
    title: 'Test and Harden',
    description:
      'AI systems fail in unexpected ways. We find them before your users do.',
  },
  {
    number: '06',
    label: 'PHASE SIX',
    title: 'Deploy and Stay',
    description: 'We deploy, monitor and stay close.',
  },
];

function Process() {
  useDocumentTitle('Our Process — MMI');

  return (
    <main className="process-page">
      <section className="process-hero">
        <div className="container">
          <div className="process-hero-grid">
            <div className="process-hero-text">
              <div className="hero-label">THE METHODOLOGY</div>
              <h1 className="hero-title">
                How We Work
                <br />
                <span className="gradient-text">No Supervise, No Vanishing Acts</span>
              </h1>
              <p className="hero-description">
                Six Steps. Clear ownership. You always know where your project stands
              </p>
            </div>
            <div className="process-hero-media">
              <div className="assert-image-wrap">
                <img src={processHeroImg} alt="MMI process" className="assert-image" />
                <div className="assert-image-glow" aria-hidden="true" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="phases-section">
        <div className="container">
          <div className="phases-list">
            {phases.map((phase, index) => (
              <div key={phase.number}>
                <article className="phase-step">
                  <div className="phase-number">{phase.number}</div>
                  <div className="phase-content">
                    <div className="phase-label">{phase.label}</div>
                    <h2 className="phase-title">{phase.title}</h2>
                    <p className="phase-description">{phase.description}</p>
                  </div>
                </article>
                {index < phases.length - 1 && <hr className="phase-divider" aria-hidden />}
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="excellence-section">
        <div className="excellence-overlay"></div>
        <div className="container">
          <div className="excellence-content">
            <h2 className="excellence-title">
              Engineered for <span className="gradient-text">Excellence</span>
            </h2>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Process;
